/** Props for a tabpanel paired with {@link SegmentedTabs} when `panelIdPrefix` is set. */
export function segmentedTabPanelProps(
  tabId: string,
  activeTabId: string,
  options: { panelIdPrefix: string; tabIdPrefix: string },
): {
  role: "tabpanel";
  id: string;
  "aria-labelledby": string;
  hidden?: boolean;
} {
  return {
    role: "tabpanel",
    id: `${options.panelIdPrefix}-${tabId}`,
    "aria-labelledby": `${options.tabIdPrefix}-${tabId}`,
    ...(tabId !== activeTabId ? { hidden: true } : {}),
  };
}
